import type { TypedContainer } from 'src/features/ioc/TypedContainer';
import type { StaticBindings } from 'src/types/bindings';

export type StaticContainer = TypedContainer<StaticBindings>;

// We choose to not extend the `globalThis` so that we are forced to import the container instead of using a global
export const container = (globalThis as any).container as StaticContainer;
